import { Form, Input } from 'antd';
import { Dispatch, FC, SetStateAction } from 'react';
import { t } from 'i18next';

import { FormItem } from 'componets/form';

import { ReactComponent as SearchIcon } from 'assets/icons/search-icon.svg';

import s from './index.module.scss';

export const NewsSearch: FC<{ onSubmit: Dispatch<SetStateAction<string>> }> = ({ onSubmit }) => {
	const onFinish = (data: { highlight: string }) => {
		onSubmit(data.highlight);
	};

	return (
		<div className={s.search}>
			<Form onFinish={onFinish}>
				<div className={s.searchInput}>
					<FormItem name="highlight">
						<Input placeholder={t('searchText')} />
					</FormItem>
					<button type="submit" className={s.searchButton}>
						<SearchIcon />
					</button>
				</div>
			</Form>
		</div>
	);
};
